import { z } from 'zod';
import validations from 'utils/validations';

// The shared AddLedgerEntry modal (add-entry-modal.tsx) only validates when a
// resolver is passed in. "description" is always the field the user actually
// fills in; "letter" only matters on screens that restrict it via
// `lettersAllowedEntry` (e.g. K/M, J/K, L/N) — pass `requireLetter: true` there.
// Every other field is left as z.any() so it passes through unvalidated
// instead of being stripped from the resolved values.
export const createAddEntrySchema = (options?: { requireLetter?: boolean }) => z.object({
  entryDate: z.any(),
  description: validations.requiredString('Required'),
  code: z.any(),
  amount: z.any(),
  kind: z.any(),
  letter: options?.requireLetter ? z.string().min(1, 'Required') : z.any(),
  amount_override: z.any(),
  number: z.any(),
  amount_calculated: z.any(),
  months_advanced: z.any(),
  months: z.any(),
  annuality: z.any(),
});
